import { createAsyncTypes } from 'utils/ActionCreator'

export const LICENSE_DATA_REQUEST_ASYNC = createAsyncTypes(
  'LICENSE_DATA_REQUEST_REQUEST',
  'IronScales/Dashboard/Home/Licenses'
)

export const TOGGLE_ADDON_TO_UNLOCK = 'IronScales/Dashboard/Home/Licenses/TOGGLE_ADDON_TO_UNLOCK'
export const RESET_SELECTED_ADDONS = 'IronScales/Dashboard/Home/Licenses/RESET_SELECTED_ADDONS'

export const ERROR_MESSAGE = 'The requested data cannot be displayed. Please try again later.'

export const ADDONS_LIST = [
  {
    name: 'URL And QR Scanning',
    image: 'url_attachment',
    description:
      'Protect against zero-day malware, credential theft, and image-based phishing threats with a real-time defense against all inbound emails.',
  },
  {
    name: 'Account Takeover Protection',
    image: 'ato_protection',
    description:
      'Prevent Microsoft email account takeover (ATO) attempts to protect user credentials, financial information, sensitive data, and more using IRONSCALES™.',
  },
  {
    name: 'Incident Management',
    image: 'incident_management',
    description:
      'Ensure every potential email threat is immediately investigated without burdening your team with extra work.',
  },
  {
    name: 'Training Campaigns + Wizer',
    image: 'security_awareness_training',
    description:
      'Ensure your employees are a strong line of defense against the latest methods of attack with relevant and entertaining training videos (Wizer).',
  },
  {
    name: 'Spear Phishing Campaigns',
    image: 'spear_phishing',
    description: 'Launch personalized AI-generated spear phishing simulation campaigns in minutes.',
  },
  {
    name: 'Themis Co-Pilot',
    image: 'themis_copilot2',
    description:
      'Empower employees to take an active role in detecting and reporting phishing threats with access to a GPT-powered chat assistant directly in their inbox. ',
  },
  {
    name: 'Autonomous Campaigns',
    image: 'autonomous_campaigns',
    description: 'Automate your phishing simulations to ensure all your employees stay sharp.',
  },
  {
    name: 'SAT Content Pack',
    image: 'premium_training_content',
    description:
      'Access hundreds of award-winning videos to enhance your employee training programs.',
  },
]

export const COMPLETE_PROTECT_CAPABILITIES = [
  'URL, Attachment And QR Scanning​',
  'Teams Protection',
  'Account Takeover Protection​',
  'Autonomous Campaigns',
  'Spear Phishing Campaigns',
  'Training Campaigns + Wizer​',
  'Themis Co-Pilot​',
]
